module.exports = __webpack_public_path__ + "static/media/pexels-suzy-hazelwood-2536965.7278cb4b.f22f56af.jpg";